import StoreFilter from "./StoreFilter";
import AllProductsList from "./AllProductsList";
import { ExtendedCloudApp, ExtendedGlobalApp } from "../../Cards/AppCard";
import { GlobalApp } from "../../../../types/GlobalInterfaces";
import { Button } from "reactstrap";
import { useState } from "react";

interface Props {
  allApps: GlobalApp[];
  mostPopularApps: ExtendedGlobalApp[];
  cloudApps: ExtendedCloudApp[];
  loading: boolean;
  openApp: (app: any) => void;
  mstags?: string[];
  onTagsChange?: (tags: string[]) => void;
  selectedTags: string[];
}

const AllProducts = ({
  allApps,
  mostPopularApps,
  cloudApps,
  loading,
  openApp,
  mstags,
  onTagsChange,
  selectedTags,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="tw:flex tw:h-full tw:gap-4 tw:flex-col tw:md:flex-row">
      <div className="tw:hidden tw:md:block">
        <StoreFilter
          mstags={mstags}
          onTagsChange={onTagsChange}
          selectedTags={selectedTags}
        />
      </div>
      <div className="tw:block tw:md:hidden tw:my-4 tw:px-2">
        <Button className="" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? "Hide Filters" : "Show Filters"}
        </Button>
        {isOpen && (
          <div className="tw:absolute tw:pb-36 tw:md:pb-0">
            <StoreFilter
              mstags={mstags}
              onTagsChange={onTagsChange}
              selectedTags={selectedTags}
            />
          </div>
        )}
      </div>

      <AllProductsList
        allApps={allApps}
        mostPopularApps={mostPopularApps}
        cloudApps={cloudApps}
        loading={loading}
        openApp={openApp}
      />
    </div>
  );
};

export default AllProducts;
